





































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import { IInvoice } from "@/models/invoices";

interface IDueDateModalForm {
  due_date: Date;
}

@Component
export default class InvoiceDueDateModal extends Mixins(RequestPromises) {
  // Props
  @Prop({ required: true })
  public dueDate!: Date;
  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];
  // Data
  public isProcessing = false;
  public form: IDueDateModalForm = {
    due_date: this.dueDate
  };

  public get minDate() {
    return this.$moment()
      .startOf("day")
      .toDate();
  }

  public get formIsValid() {
    if (!this.$_.isDate(this.form.due_date)) return false;
    if (this.$_.isEqual(this.dueDate, this.form.due_date)) return false;
    return true;
  }

  public async validateBeforeSubmit() {
    if (!this.formIsValid) return;
    this.isProcessing = true;
    try {
      await this.$store.dispatch(`data/${DataModules.INVOICES}/update`, {
        id: this.invoiceId,
        data: this.form
      });
      this.$emit("close");
      this.$emit("changed");
      this.$buefy.toast.open({
        message: this.$t("_.object_changed", {
          object: this.$t("_.due_date")
        }) as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }
}
